var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 18,
    viewBox: "0 0 32 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9502 17.1681L30.889 2.53893C31.1217 2.29484 31.2515 1.97054 31.2515 1.63331C31.2515 1.29607 31.1217 0.971777 30.889 0.727684L30.8732 0.711931C30.7604 0.593189 30.6246 0.498638 30.4741 0.434027C30.3236 0.369417 30.1616 0.336098 29.9978 0.336098C29.834 0.336098 29.6719 0.369417 29.5214 0.434027C29.3709 0.498638 29.2351 0.593189 29.1223 0.711931L15.9973 14.4879L2.87759 0.711929C2.76479 0.593187 2.629 0.498636 2.47851 0.434024C2.32801 0.369415 2.16594 0.336095 2.00215 0.336095C1.83837 0.336095 1.6763 0.369415 1.5258 0.434024C1.3753 0.498636 1.23952 0.593187 1.12672 0.711929L1.11097 0.727681C0.878273 0.971774 0.748464 1.29607 0.748464 1.6333C0.748464 1.97054 0.878272 2.29484 1.11097 2.53893L15.0497 17.1681C15.1723 17.2967 15.3197 17.3991 15.4831 17.4691C15.6464 17.5391 15.8223 17.5752 16 17.5752C16.1777 17.5752 16.3535 17.5391 16.5169 17.4691C16.6802 17.3991 16.8276 17.2967 16.9502 17.1681Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.082ca8e53da0281ed05d6063280b449a.svg";
export { ForwardRef as ReactComponent };